import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0 0;
  margin: 0 20px;
`;
